const leases=new Map<string,string>();
export function setCampaignLease(projectId:string,value:string|null) {
  if(value)leases.set(projectId,value);else leases.delete(projectId);
}
export function campaignLeaseHeader(path:string):Record<string,string> {
  const match=/^\/api\/projects\/([^/?]+)(?:\/|$)/.exec(path);
  if(!match)return {};
  const token=leases.get(decodeURIComponent(match[1]));
  return token?{'X-Campaign-Lease':token}:{};
}
